export const getPosts = state => state.PostReducer.posts;
export const getCurrentPage = state => state.PostReducer.currentPage;
